import React from "react"
import Icon from "../../Icon/Icon"
import * as Yup from "yup"
import TextField from "../TextField/TextField"

const jwtPublicKeySchema = Yup.string().required("Public Key is required")

const jwtIssuerSchema = Yup.string().required("JWT Issuer is required")

export default function CustomFields() {
	return (
		<fieldset className="fields">
			<TextField
				name="jwtPublicKey"
				label="Public Key"
				type="textarea"
				placeholder={`----- BEGIN KEY -----


----- END KEY -----`}
				validationSchema={jwtPublicKeySchema}
				helpElements={
					<>
						<Icon
							icon="information-circle--interface-essential"
							size={12}
							data-tip="React-tooltip"
							data-for="jwks-path-tooltip"
						/>
						<a className="jwks-button link" href="https://jwt.io/introduction" target="_blank" rel="noreferrer">
							How to find my JWKS
						</a>
					</>
				}
				additionalContent={
					<div className="description">
						<svg
							viewBox="0 0 1024 1024"
							style={{
								stroke: "currentcolor",
								fill: "currentcolor",
								width: "12px",
								height: "12px",
							}}
						>
							<path d="M512 85.334c-235.641 0-426.666 191.025-426.666 426.666 0 235.643 191.025 426.665 426.666 426.665 235.643 0 426.665-191.022 426.665-426.665 0-235.641-191.022-426.666-426.665-426.666zM0 512c0-282.77 229.23-512 512-512 282.767 0 512 229.23 512 512 0 282.767-229.233 512-512 512-282.77 0-512-229.233-512-512z" />
							<path d="M554.665 298.666h-85.331v-85.334h85.331v85.334z" />
							<path d="M469.334 469.334h-85.334v-85.334h170.665v298.665h85.335v85.335h-256v-85.335h85.334v-213.331z" />
						</svg>
						<p>Remove BEGIN line, END line, and any line breaks.</p>
					</div>
				}
			/>
			<TextField name="jwtIssuer" label="JWT Issuer" placeholder="Issuer" validationSchema={jwtIssuerSchema} />
		</fieldset>
	)
}
